import React, { useEffect, useState } from 'react';
import { faTruck, faCirclePause, faCirclePlay, faFile, faSquarePollHorizontal, faCirclePlus, faCircleXmark, faPlus, faClose, faFileCircleXmark, faFileLines, faFileImport, faArrowRightFromBracket, faChartColumn, faChartPie,faSquarePollVertical, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CardControleDocaComponent = (props: any) => {
    const [classModoDark, setClassModoDark] = useState(' bg-dark text-white'); 
    const [letraPainel, setletraPainel] = useState('#57f542');
    
    const [preferences, setPreferences] = useState<any | null>(() => {
        const storedPreferences = localStorage.getItem("preferences");
        return storedPreferences ? JSON.parse(storedPreferences) : [];
    });

    useEffect(() => {
        if(preferences.darkMode == true){
            setClassModoDark(' bg-dark text-white');
            setletraPainel('#57f542');
        } else {
            setClassModoDark(' bg-light');
        }
    }, []);

    return (
    <div
        className={"card-group card-group-doca' width-doca-progress-bar m-1 "+((props.dadosDoca.placa??'')!='' ? '' : 'controle-doca-cursor-pointer')}
        style={{width: '200px'}}
        onClick={() => props.cardClick(props.dadosDoca)}>
        <div className={"card " + classModoDark} style={{borderRadius:'20px', paddingTop: '5px'}}>
            <div className="card-body" style={{textAlign:'center', fontSize:'18pt', fontWeight: 'bold'}}>
                <section className='card-doca'>
                    <div
                        style={{backgroundColor:props.dadosDoca.cor, borderRadius:'5px', marginBottom: '15px',color:'#fff'}} 
                        onClick={() => props.topCardClick(props.dadosDoca)}
                        className='controle-doca-cursor-pointer controle-doca-clickable'
                    >
                        {props.dadosDoca.numero_doca}
                        
                        {(props.dadosDoca.placa??'')=='' ? 
                        <FontAwesomeIcon
                            color={'white'}
                            style={{position: 'absolute', right:'12px', filter: "brightness(20%)", fontWeight: ''}}
                            icon={faPlusCircle}
                            size={"sm"} />
                        :
                        <FontAwesomeIcon
                            color={props.dadosDoca.cor}
                            style={{position: 'absolute', right:'12px', filter: "brightness(90%)"}}
                            icon={faCircleXmark}
                            size={"sm"} />
                        }
                    </div>

                    <span className='tempo_doca'>{props.dadosDoca.tempo_doca ?? props.dadosDoca.tempo_vazia}</span>
                  
                    <div>
                        {(props.dadosDoca.placa??'')!='' ?
                            <div>
                            {/* <FontAwesomeIcon
                                color='#999'
                                style={{position: 'absolute', opacity: "0.4", marginTop:'5px', marginLeft: '2px'}}
                                icon={faPlus}
                                size={"2xs"} /> */}
                                
                            <FontAwesomeIcon
                                color='#777'
                                style={{position: 'absolute', opacity: "0.3", marginTop:'1px', marginLeft: '1px'}}
                                icon={faFile}
                                size={"sm"}
                                onClick={() => props.veiculoClick(props.dadosDoca)}
                                className='controle-doca-cursor-pointer controle-doca-clickable' />

                            <FontAwesomeIcon
                                icon={faTruck}
                                size={"2xl"}
                                onClick={() => props.veiculoClick(props.dadosDoca)}
                                className='controle-doca-cursor-pointer controle-doca-clickable ' />
                            </div>
                        : ""}
                    </div>
                    
                    {(props.dadosDoca.placa??'')!='' ? 
                    <div style={{marginBottom: '15px', marginLeft:'-15px'}} onClick={() => props.placaClick(props.dadosDoca)} className='controle-doca-cursor-pointer controle-doca-clickable'>
                        
                        <FontAwesomeIcon
                            style={{opacity: "0.07"}}
                            icon={faSquarePollHorizontal}
                            size={"sm"}
                            className='controle-doca-cursor-pointer controle-doca-clickable' />

                        {props.dadosDoca.placa}
                    </div>
                    : ""}

                    {(props.dadosDoca.placa??'')!='' ? 
                    <span className='area-controle-doca-play-pause'>
                        <div>{props.dadosDoca.tempo_pausa_atual}</div>
                        <div className='controle-doca-cursor-pointer controle-doca-clickable'>
                            {props.dadosDoca.tempo_pausa_atual==null ?
                                <FontAwesomeIcon icon={faCirclePause} size={"xl"} onClick={() => props.pauseClick(props.dadosDoca)} /> :
                                <FontAwesomeIcon icon={faCirclePlay} size={"xl"} onClick={() => props.playAgainClick(props.dadosDoca)} />}
                        </div>
                    </span>
                    : ""}
                </section>
            </div>
        </div>
    </div>
    );
}

export default CardControleDocaComponent